// extracted by mini-css-extract-plugin
module.exports = {"body":"App_body__ZTvxg","anchor":"App_anchor__1UhLS","navigation":"App_navigation__3pqZF"};